import React from 'react'
import { useAnalyticsOverview } from '../../../hooks'
import { Area, AreaChart } from 'recharts'

import { match } from 'ts-pattern'
import { ChartContainer, type ChartConfig } from '@bpinternal/ui-kit-next'

type Props = {
  botId: string
  workspaceId: string
  color?: 1 | 2 | 3 | 4 | 5
}

export const AnalyticsWidget = ({ botId, workspaceId, color = 1 }: Props) => {
  const analytics = useAnalyticsOverview({ botId, workspaceId }).data.records

  const data = match(analytics.length)
    // Add 2 empty data points to make a straight line when no values
    .with(0, () => [
      { endDateTimeUtc: new Date().toISOString(), messages: 0 },
      { endDateTimeUtc: new Date().toISOString(), messages: 0 },
    ])
    // Duplicate the data to make it look like a straight line if only a single data point
    .with(1, () => [...analytics, ...analytics])
    .otherwise(() => analytics)

  const chartConfig = {
    messages: {
      label: 'Messages',
      color: `hsl(var(--chart-${color}))`,
    },
  } satisfies ChartConfig

  return (
    <ChartContainer config={chartConfig} className="h-32 w-full">
      <AreaChart
        accessibilityLayer
        data={data}
        margin={{
          top: 16,
          bottom: 16,
        }}
      >
        <defs>
          <linearGradient id={`fillMessages-${botId}`} x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="var(--color-messages)" stopOpacity={0.8} />
            <stop offset="95%" stopColor="var(--color-messages)" stopOpacity={0.1} />
          </linearGradient>
        </defs>
        <Area
          dataKey="messages"
          type="bump"
          strokeWidth={1.5}
          fill={`url(#fillMessages-${botId})`}
          fillOpacity={0.4}
          stroke="var(--color-messages)"
          stackId="a"
        />
      </AreaChart>
    </ChartContainer>
  )
}
